/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import TargetEnum from '../../../target-enum';
import TaskEnum from '../../../task/task-enum';

/**
 * Převaděč obsahových úloh na staré úlohy
 */
class ContentTaskToTaskConverter {
  /** Vytvoří instanci. */
  constructor() {
    /**
     * Cíl, který odpovídá hodnotě {@link TargetEnum.PRIMARY}.
     * @private
     * @type {string}
     */
    this.primaryTarget = 'display1.primary';
  }

  /**
   * Převede obsahovou úlohu na starou úlohu
   * @param {ContentTask} contentTask
   * @param {Store} store
   * @returns {Task|undefined} Pokud nelze starou úlohu vytvořit,
   * vrací `undefined`.
   */
  convert(contentTask, store) {
    // Úloha musí mít známý cíl, jinak nelze převést.
    if (contentTask.target !== this.primaryTarget) {
      return;
    }
    // Vytvoření úlohy v požadovaném datovém skladu.
    return store.inject('task', {
      id: contentTask.id,
      layoutId: contentTask.layoutId ?? null,
      mediumId: contentTask.mediumId ?? null,
      planIcal: contentTask.planIcal,
      playlistId: contentTask.playlistId ?? null,
      priority: contentTask.priority,
      targetEnum: TargetEnum.PRIMARY,
      taskEnum: TaskEnum.CONTENT
    });
  }
}

export default ContentTaskToTaskConverter;
